import SWLink from './SWLink'
export type { SWLinkProps } from './SWLink'
export default SWLink
